// extracted by mini-css-extract-plugin
export var root = "h_Z";
export var heading = "h_G";
export var cnt = "h_0";
export var wrapper = "h_b";
export var offers = "h_1";
export var spacer = "h_j";
export var desc = "h_H";
export var figure = "h_2";
export var dots = "h_3";
export var info = "h_4";